import {
  loadPastMaintenancesFailed,
  loadPastMaintenancesSucceeded,
} from './actionCreators';
import { ActionTypes } from './actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  MaintenanceRequester,
  type PastMaintenancesMaps,
} from '@cobliteam/api-lib';

import { AlertTypes, showAlertActionCreator } from '@cobliteam/alert';
import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();

export const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

export function* requestPastMaintenancesSaga() {
  try {
    const pastMaintenancesMap: PastMaintenancesMaps = yield call(
      maintenanceRequester.loadPastMaintenances
    );
    yield put(loadPastMaintenancesSucceeded(pastMaintenancesMap));
  } catch (err) {
    yield put(loadPastMaintenancesFailed());
    yield put(
      showAlertActionCreator(
        AlertTypes.ERROR,
        'Falha ao carregar manutenções. Tente novamente mais tarde.'
      )
    );
  }
}

export function* PastMaintenancesSagasListener() {
  yield all([
    takeLatest(
      ActionTypes.LOAD_PAST_MAINTENANCES_REQUEST,
      requestPastMaintenancesSaga
    ),
  ]);
}
